import React from "react";

function PlayerHand({ hand, playCard, isMyTurn }) {

    if(!hand){
        return <div>Hello</div>
    }

  return (
    <div style={{ marginTop: 20 }}>
      <h3>Mâna ta</h3>
      {hand.length === 0 && <p>Nu ai cărți!</p>}
      {hand.map((card, i) => (
        <button
          key={i}
          onClick={() => isMyTurn && playCard(card)}
          disabled={!isMyTurn}
          style={{
            margin: 5,
            padding: "10px 15px",
            fontSize: "16px",
            background: isMyTurn ? "#eee" : "#ccc"
          }}
        >
          {card.rank}{card.suit}
        </button>
      ))}
    </div>
  );
}

export default PlayerHand;
